export default {
  d: "M0,90c0,49.6,40.4,90,90,90s90-40.4,90-90S139.6,0,90,0S0,40.4,0,90z M90,20v140c-38.6,0-70-31.4-70-70S51.4,20,90,20z",
  viewBox: "0 0 180 180"
}
